import type {RecordEditation} from 'src/typings';
import type {PromiseBasedRecordEditationDataService, RecordEditationAction} from '../types';
import type {Observable} from 'rxjs';
import {GenericEditationAction} from './generic-editation-action';
import {from} from 'rxjs';

export class RemoveAction extends GenericEditationAction implements RecordEditationAction {
    constructor(private backend: PromiseBasedRecordEditationDataService) {
        super('RemoveAction');
    }

    public executeAction(editationObject: RecordEditation): Observable<RecordEditation> {
        return from(this.backend.remove(editationObject.id));
    }
}